// Import de funcions auxiliars
import {
    obteVariable,
    obteValorVariable,
    afegeixErrorAVariable
}  from './utils';

/*
 * Per facilitar la lectura del codi s'afegeixen els identificadors de variables a mode de constants
 ***/
export const ID_PRESSIO_A_NIVELL_DE_L_ESTACIO_I_REDUIDA_A_0C = 24;
export const ID_PRESSIO_MINIMA_A_NIVELL_DE_L_ESTACIO_I_REDUIDA_A_0C = 27;
export const ID_PRESSIO_MAXIMA_A_NIVELL_DE_L_ESTACIO_I_REDUIDA_A_0C = 25;

/*
 * Missatges d'error propis del grup
 ***/
export const MSG_PRESSIO_MIN_INFERIOR_O_IGUAL_PRESSIO_ESTACIO = 'La pressió mínima ha de ser inferior o igual a la pressió a nivell de l\'estació i reduïda a 0ºC.';
export const MSG_PRESSIO_MAX_SUPERIOR_O_IGUAL_PRESSIO_ESTACIO ='La pressió màxima ha de ser superior o igual a la pressió a nivell de l\'estació i reduïda a 0ºC.';
export const MSG_PRESSIO_MAX_SUPERIOR_O_IGUAL_PRESSIO_MIN = 'La pressió màxima ha de ser superior o igual a la pressió mínima.';

/*
 * Funcions auxiliars que ajuden a la legibilitat
 ***/
const checkPressioMinInferiorOIgualPressioEstacio = (pressioMinimaValor, pressioValor) => {
    return pressioMinimaValor !== null && pressioValor !== null &&
        pressioMinimaValor > pressioValor;
};

const checkPressioMaxSuperiorOIgualPressioEstacio = (pressioMaximaValor, pressioValor) => {
    return pressioMaximaValor !== null && pressioValor !== null &&
        pressioMaximaValor < pressioValor;
};

const checkPressioMaxSuperiorOIgualPressioMin = (pressioMinimaValor, pressioMaximaValor) => {
    return pressioMinimaValor !== null && pressioMaximaValor !== null &&
        pressioMinimaValor > pressioMaximaValor;
};

/*
 * Grup Pressió atmosfèrica
 ***/
export const checkGrupPressioAtmosferica = (nouVariables) => {

    // Variables
    const pressioANivellDeLEstacioIReduidaA0C = obteVariable(ID_PRESSIO_A_NIVELL_DE_L_ESTACIO_I_REDUIDA_A_0C, nouVariables);
    const pressioMinimaANivellDeLEstacioIReduidaA0C = obteVariable(ID_PRESSIO_MINIMA_A_NIVELL_DE_L_ESTACIO_I_REDUIDA_A_0C, nouVariables);
    const pressioMaximaANivellDeLEstacioIReduidaA0C = obteVariable(ID_PRESSIO_MAXIMA_A_NIVELL_DE_L_ESTACIO_I_REDUIDA_A_0C, nouVariables);

    // Valors de variables
    const pressioANivellDeLEstacioIReduidaA0CValor = obteValorVariable(pressioANivellDeLEstacioIReduidaA0C);
    const pressioMinimaANivellDeLEstacioIReduidaA0CValor = obteValorVariable(pressioMinimaANivellDeLEstacioIReduidaA0C);
    const pressioMaximaANivellDeLEstacioIReduidaA0CValor = obteValorVariable(pressioMaximaANivellDeLEstacioIReduidaA0C);

    if (pressioMinimaANivellDeLEstacioIReduidaA0C && pressioANivellDeLEstacioIReduidaA0C) {
        // PRESSIO_MINIMA_A_NIVELL_DE_L_ESTACIO_I_REDUIDA_A_0C <= PRESSIO_A_NIVELL_DE_L_ESTACIO_I_REDUIDA_A_0C
        if (checkPressioMinInferiorOIgualPressioEstacio(pressioMinimaANivellDeLEstacioIReduidaA0CValor, pressioANivellDeLEstacioIReduidaA0CValor)) {
            afegeixErrorAVariable(pressioMinimaANivellDeLEstacioIReduidaA0C, MSG_PRESSIO_MIN_INFERIOR_O_IGUAL_PRESSIO_ESTACIO);
            afegeixErrorAVariable(pressioANivellDeLEstacioIReduidaA0C, MSG_PRESSIO_MIN_INFERIOR_O_IGUAL_PRESSIO_ESTACIO);
        }
    }

    if (pressioMaximaANivellDeLEstacioIReduidaA0C && pressioANivellDeLEstacioIReduidaA0C) {
        // PRESSIO_MAXIMA_A_NIVELL_DE_L_ESTACIO_I_REDUIDA_A_0C >= PRESSIO_A_NIVELL_DE_L_ESTACIO_I_REDUIDA_A_0C
        if (checkPressioMaxSuperiorOIgualPressioEstacio(pressioMaximaANivellDeLEstacioIReduidaA0CValor, pressioANivellDeLEstacioIReduidaA0CValor)) {
            afegeixErrorAVariable(pressioMaximaANivellDeLEstacioIReduidaA0C, MSG_PRESSIO_MAX_SUPERIOR_O_IGUAL_PRESSIO_ESTACIO);
            afegeixErrorAVariable(pressioANivellDeLEstacioIReduidaA0C, MSG_PRESSIO_MAX_SUPERIOR_O_IGUAL_PRESSIO_ESTACIO);
        }
    }

    if (pressioMaximaANivellDeLEstacioIReduidaA0C && pressioMinimaANivellDeLEstacioIReduidaA0C) {
        // PRESSIO_MINIMA_A_NIVELL_DE_L_ESTACIO_I_REDUIDA_A_0C <= PRESSIO_MAXIMA_A_NIVELL_DE_L_ESTACIO_I_REDUIDA_A_0C
        if (checkPressioMaxSuperiorOIgualPressioMin(pressioMinimaANivellDeLEstacioIReduidaA0CValor, pressioMaximaANivellDeLEstacioIReduidaA0CValor)) {
            afegeixErrorAVariable(pressioMinimaANivellDeLEstacioIReduidaA0C, MSG_PRESSIO_MAX_SUPERIOR_O_IGUAL_PRESSIO_MIN);
            afegeixErrorAVariable(pressioMaximaANivellDeLEstacioIReduidaA0C, MSG_PRESSIO_MAX_SUPERIOR_O_IGUAL_PRESSIO_MIN);
        }
    }

};



// WEBPACK FOOTER //
// ./src/reducers/observacio/formulari/filtresCoherencia/grupPressioAtmosferica.js